import React, { useState, useContext, useEffect } from 'react';
import {  Link } from 'react-router-dom';
import './DeleteProfile.css';
import profileTypesData from "../../../../Data/App_data/app_fixed_data.json";
import Modal from "react-modal";
import { ProfileContext } from "../../../../context/ProfileContext";
import { useNavigate } from "react-router-dom";
import { FaUpload } from "react-icons/fa"; // Importing Upload Icon
import { left } from '@popperjs/core';
import { ThemeContext } from "../../../../context/ThemeContext";
import {validateProfile} from "../../../../utils/profileUtils";
import UploadInput from "../../../common/MediaUpload/mediaupload"
import CommonDropdown from "../../../UI-comp/CommonDropdown";
import ProfilePopover from "../../../common/ProfileButton/ProfilePopover";
import kleidologo from "../../../../assets/images/Kleido.png"

const DeleteProfile = () => {
  const [formData, setFormData] = useState({
    userId: '',
    profileType: '',
    profileName: '',
  });

  const { profiles, addProfile } = useContext(ProfileContext);
  const [userId, setuserId] = useState("");
  const [profileType, setProfileType] = useState("");
  const [date, setDate] = useState("");
  const [location, setlocation] = useState("");
  const [error, setError] = useState("");
  const [useCustomName, setUseCustomName] = useState(false);
  const [customProfileName, setCustomProfileName] = useState("");
  const [profilepic, setProfilePic] = useState(""); 
  const [errorMessage, setErrorMessage] = useState(""); // Added error handling
  const navigate = useNavigate();
  const [fileName, setFileName] = useState("");
  const [mediaName, setMediaName] = useState("");
  const [defaultProfileName, setdefaultProfileName] = useState("");
  const { theme } = useContext(ThemeContext);
  const [acceptedTerms, setAcceptedTerms] = useState("");
  const profileName = useCustomName ? customProfileName : defaultProfileName;
  const [selectedFile, setSelectedFile] = useState(null);

  // useEffect(() => {
  //       import(`./Styles/themes/${theme}/themes.css`).then(() => {
  //         console.log(`Loaded ${theme} styles for User Account`);
  //       }).catch(() => {
  //         console.error(`Theme CSS not found for ${theme}`);
  //       });
  //     }, [theme]);

  useEffect(() => {
    if (!useCustomName && userId && profileType) {
      setdefaultProfileName(`${userId}_${profileType}`);
    }
  }, [userId, profileType, useCustomName]);

  const handleUploadClick = () => {
    const choice = window.confirm("Do you want to upload from local device? Click 'Cancel' for cloud storage.");
    if (choice) {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.onchange = (e) => {
        const file = e.target.files[0];
          if (file) {
            setFileName(file.name);         // Just name
            setSelectedFile(file);          // Actual file data
          }
        };
        input.click();
    } else {
        const url = window.prompt("Enter cloud storage URL:");
        if (url) {
          setFileName(url);
          setSelectedFile(null); // No actual file to upload from URL
        }
    }
  };

  const handleMediaUploadClick = () => {
    const choice = window.confirm(
      "Do you want to upload from local device? Click 'Cancel' for cloud storage."
    );
  
    if (choice) {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".mp4,.mov,.jpeg,.jpg,.png,.txt"; // Accept various media types
      input.onchange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
          const file = e.target.files[0];
          if (file.Name) {
            setMediaName(file.name);         // Just name
            setSelectedFile(file);          // Actual file data
          }
          // Optional: If you want to upload the file or preview it, do it here.
          // Example: setProfilePic(URL.createObjectURL(file));
        }
      };
      input.click();
    } else {
      const url = window.prompt("Enter cloud storage URL:");
      if (url) {
        setMediaName(url);
        setSelectedFile(null); // No actual file to upload from URL
      }
    }
  };
  
  const handleUpload = () => {
    if (!selectedFile) {
      alert("Please select a file first.");
      return;
    }
  
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64Image = reader.result;
      localStorage.setItem("uploadedImage", base64Image);
      alert("Image uploaded and saved to localStorage!");
    };
    reader.readAsDataURL(selectedFile);
  };
  

  const handleSubmit = async (event) => {
    event.preventDefault();
  
    const errorMessage = validateProfile(
      profiles,
      profileType,
      profileName,
      profileTypesData.Max_Profile_Limit
    );
    if (errorMessage) {
      setError(errorMessage);
      return;
    }
  
    // Clear errors
    setError("");
  
    // No destructuring needed
    // const { userId, profileType, profileName } = formData;
  
    const newProfile = {
      value: profileType,
      label: profileName,
      profileType,
      profileName,
      location,
      date,
    };
  
    addProfile(newProfile);
  
    try {
      const response = {
        ok: true,
        json: async () => ({ message: "Mock signup successful" }),
      };
  
      const result = await response.json();
      if (response.ok) {
        alert(
          `Profile Created:\nUserId: ${userId}\nProfile Type: ${profileType}\nProfile Name: ${profileName}\nDate: ${date}`
        );
  
        handleDeleteProfile({ userId, profileType, profileName });
      } else {
        alert("Create Profile failed: " + result.message);
      }
    } catch (error) {
      setErrorMessage(error.message || 'Create Profile failed.');
    }
  
    setErrorMessage('');
  };
  

  const handleDeleteProfile = (eOrData) => {
    let data;
  
    if (eOrData?.preventDefault) {
      eOrData.preventDefault();
      data = formData;
    } else {
      data = eOrData;
    }
  
    let profiles = JSON.parse(localStorage.getItem('profiles')) || [];
  
    // Check if user with same userId OR email OR mobile exists
    const existingIndex = profiles.findIndex(
      (profile) =>
        profile.userId === data.userId ||
        profile.profileType === data.profileType ||
        profile.profileName === data.profileName
    );
  
    if (existingIndex !== -1) {
      // If exists, update the user info
      profiles[existingIndex] = {
        ...profiles[existingIndex],
        ...data,
      };
      alert("Profile info updated in localStorage.");
    } else {
      // Else, push new user
      profiles.push(data);
      alert("New profile added to localStorage.");
    }
  
    localStorage.setItem('profiles', JSON.stringify(profiles));
  
    setFormData({
      userId: '',
      profileType: '',
      profileName: ''
    });
  };

  const dropdownOptions = profileTypesData.Profile_Types.map((type) => ({
    value: type,
    label: type,
  }));

  const submit = () => {
    // Simulate profile creation logic
    navigate("/ProfileCreateStatus");
  };
  
return (
<div className="cp-auth-container">
  <div className="pc-form-container" style={{marginTop: 60, width: 600}}>
    <div className= "form-box-header">
      <h2>
        Delete Profile
      </h2>
      <img
          src={kleidologo}
          className="logo-default-container-img"
       />
    </div>
    {errorMessage && <p className="error-message">{errorMessage}</p>}

    <form onSubmit={handleSubmit}>
      {/* User ID */}
      <div className="pc-form-group-row">
        <div className="pc-form-group">
          <label>* User Id</label>
          <input
            type="text"
            name="userId"
            value={userId}
            onChange={(e) => setuserId(e.target.value)}
            required
          />
        </div>
      </div>

      {/* Profile Type */}
      <div className="pc-form-group-row" style={{marginTop: 20}}>
        <div className="pc-form-group">
          <label>* Profile Type</label>
          <CommonDropdown style={{ fontFamily: "Poppins", color: "black", fontSize: "15px" }}
              options={dropdownOptions}
              value={profileType}
              onChange={setProfileType}
              placeholder="-- Select a Profile Type --"
          />
        </div>
      </div>

      {/* Customized Profile */}
      <div className="pc-form-group-row" style={{marginLeft: 100, marginTop: 10}}>
        <div className="pc-form-group">
          <div className="pc-checkbox-container">
            <input
              type="checkbox"
              checked={useCustomName}
              onChange={(e) => setUseCustomName(e.target.checked)}
              style={{ marginLeft: -50 }}
            />
            <label style={{ fontFamily: "Poppins", color: "black", fontSize: "15px" }}>
              Customized Profile
            </label>
          </div>
        </div>
      </div>

      {/* Profile Name */}
      <div className="pc-form-group-row" style={{marginLeft: 10}}>
      <div className="pc-form-group">
        {useCustomName ? (
          <>
            <label htmlFor="customProfileName" style={{ fontFamily: "Poppins", color: "black", fontSize: "15px" }}>
              Custom Profile Name:
            </label>
            <input
              type="text"
              id="customProfileName"
              value={customProfileName}
              onChange={(e) => setCustomProfileName(e.target.value)}
              placeholder="Enter custom profile name"
              required
            />
          </>
        ) : (
          <input
            type="text"
            id="profileName"
            value={defaultProfileName}
            disabled
            readOnly
            placeholder="Generated profile name"
          />
        )}
      </div>
      </div>

      {/* Profile Picture */}
      <div className="pc-form-group-row" style={{marginTop: 30}}>
        <div className="pc-form-group">
          <label>
            Profile Picture (Generate with <Link to="/" style={{ color: "blue", fontSize: "14px" }}>Metaverse</Link>)
          </label>

          <div className="pc-profilepic" style={{height: 60, overflow: "hidden", marginTop: 10}}>
            <input 
              type="text"
              value={fileName}
              className="pc-uploadimage"
              readOnly
              placeholder="No file chosen"
              style={{marginTop: 0}}
            />
            <span className="pc-imageupload" onClick={handleUploadClick}>
              <FaUpload className="pc-upload-icon" />
            </span>
          </div>
        </div>
          <button
            type="button"
            onClick={handleUpload}
            style={{
              fontFamily: "Poppins",
              color: "white",
              fontSize: "15px",
              width: 90,
              height: 40,
              backgroundColor: "green",
              marginTop: 35,
              borderRadius: 10
            }}
          >
            Upload
          </button>
      </div>

      <div className="pc-form-group-row" style={{marginTop: 30}}>
        <div className="pc-form-group">
          <label>
            Media Upload
          </label>

          <div className="pc-mediaupload" style={{height: 60, overflow: "hidden"}}>
            <input 
              type="text"
              value={mediaName}
              className="pc-imageupload"
              readOnly
              placeholder="No file chosen"
              style={{marginTop: 0, width: "310px"}}
            />
            <span className="pc-imageupload" onClick={handleMediaUploadClick}>
              <FaUpload className="pc-upload-icon" />
            </span>
          </div>
          </div>
        <div>
          <button
            type="button"
            onClick={UploadInput}
            style={{
              fontFamily: "Poppins",
              color: "white",
              fontSize: "15px",
              width: 90,
              height: 40,
              backgroundColor: "green",
              marginTop: 35,
              borderRadius: 10
            }}
          >
            Upload
          </button>
      </div>
      </div>

      {/* Location */}
      <div className="pc-form-group-row" style={{marginTop: 10}}>
        <div className="pc-form-group">
          <label htmlFor="location" style={{ fontFamily: "Poppins", color: "black", fontSize: "15px" }}>
            Location:
          </label>
          <input
            type="text"
            value={location}
            onChange={(e) => setlocation(e.target.value)}
            required
          />
        </div>
      </div>

      {/* Captured Date */}
      <div className="pc-form-group-row" style={{marginTop: 10}}>
        <div className="pc-form-group">
          <label htmlFor="date" style={{marginTop: 10}}>* Captured Date</label>
          <input
            style={{marginTop: 10}}
            type="date"
            name="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
        <div>
        <button
          type="button"
          onClick={handleSubmit}
          style={{
            fontFamily: "Poppins",
            color: "white",
            fontSize: "15px",
            width: 100,
            height: 40,
            backgroundColor: "green",
            marginTop: 50,
            borderRadius: 10,
          }}
        >
          Create Post
        </button>
      </div>
      </div>
      {/* Terms & Conditions */}
      <div className="pc-form-group-row">
        <div className="form-group terms-conditions">
          <input
            type="checkbox"
            id="terms"
            checked={acceptedTerms}
            onChange={() => setAcceptedTerms(!acceptedTerms)}
          />
          <label htmlFor="terms">
            I accept the 
            <Link to="/privacy-policy" style={{ color: "#007BFF", marginLeft: "5px" }} target="_blank">
              Terms and Conditions
            </Link>
          </label>
        </div>
      </div>

      {/* Create profile Button */}
      <div>
        <button
          type="submit"
          disabled={!acceptedTerms}
          className="submit-btn"
          style={{ height: 50, width: "100%" }}
        >
          Submit
        </button>
      </div>

      <div className="copyright-container" style={{marginTop: 40}}>
        <p className="copyright">
          Kleido © InitiumNet Technology Pvt Ltd. For more on privacy policies and cookies, click
          <Link to="/" style={{ color: "#007BFF", marginLeft: "5px" }}>here</Link>.
        </p>
      </div>
    </form>
  </div> 
</div>
);
};

export default DeleteProfile;

